import { LoaderFunctionArgs, redirect } from 'react-router-dom'
import paymentPageLoader from './paymentPageLoader'
import getTransaction from '../api/getTransaction'
import { PaymentPageInfo } from '../types/paymentPageInfo'
import { TransactionResult } from '../types/TransactionResult'

export interface ApplePayPageData {
    paymentPageInfo: PaymentPageInfo
    transaction: TransactionResult
}

const applePayPageLoader = async (args: LoaderFunctionArgs): Promise<ApplePayPageData> => {
    const { paymentPageId, transactionId } = args.params

    if (!paymentPageId || !transactionId) {
        throw new Response('Payment page ID and transaction ID are required', { status: 400 })
    }

    const [paymentPageInfo, transaction] = await Promise.all([
        paymentPageLoader({...args, params: { ...args.params, method: 'apple' }}),
        getTransaction(paymentPageId, transactionId),
    ])

    if (transaction.type !== 'init') {
        throw redirect(`/result/${paymentPageInfo.id}/${transaction.transactionId}`)
    }

    return { paymentPageInfo, transaction }
}

export default applePayPageLoader
